"use strict";
/*eslint no-unused-vars: ["off"]*/

const angular = require("angular");
const uiRouter = require("angular-ui-router");

import routes from "./permission.routes";
import PermissionController from "./permission.controller";
import Condition from "./condition.service";
import board from "./board/board.component";
import introduction from "./introduction/introduction.component";
import project from "./project/project.component";
import product from "./product/product.component";
import identification from "./identification/identification.component";
import client from "./client/client.component";
import share from "./share/share.component";
import duplicate from "./duplicate/duplicate.component";
import validation from "./validation/validation.component";
import ProductAPI from "./product/product.service";
import ProjectAPI from "./project/project.service";
import IdentificationAPI from "./identification/identification.service";

import matchHeight from "jquery-match-height";

export default angular
  .module("dalApp.permission", [
    uiRouter,
    board,
    Condition,
    introduction,
    project,
    ProjectAPI,
    product,
    ProductAPI,
    identification,
    IdentificationAPI,
    client,
    share,
    duplicate,
    validation,
  ])
  .config(routes)
  .controller("PermissionController", PermissionController).name;



// WEBPACK FOOTER //
// ./client/app/permission/index.js